import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadSimpleIcon } from '@fronton/icons-react';
import { LinkWithGAClickButton, Typography } from 'common/components';
import { WINDOWS_CDN_PATH, WINDOWS_ELEMENT_BLOCK } from '../../../windows-constants';
import { BrandName } from '../../../windows-types';
import { CERTIFICATE_BLOCK_MAP } from './certificate-block-constants';
import {
  certificateBlock,
  certificateBlockBanner,
  certificateBlockText,
  certificateBlockTextIcon,
  certificateBlockTextContainer,
  certificateBlockTextWrapper,
} from './certificate-block-styles';

type CertificateBlockProps = {
  type: BrandName;
};

export const CertificateBlock = memo(({ type }: CertificateBlockProps) => {
  const { t } = useTranslation();
  const { href, title } = CERTIFICATE_BLOCK_MAP[type];

  return (
    <LinkWithGAClickButton
      className={certificateBlock}
      elementBlock={WINDOWS_ELEMENT_BLOCK}
      elementName={t('interior-gallery-section.button')}
      elementText="Выполненные проекты"
      href={href}
      target="_blank"
      title={title}>
      <div className={certificateBlockTextContainer}>
        <div className={certificateBlockTextWrapper}>
          <DownloadSimpleIcon
            className={certificateBlockTextIcon}
            type="outline"
            size="l"
            color="text-primary"
          />
          <Typography className={certificateBlockText} variant="l" size="subtitle">
            {t('interior-gallery-section.button')}
          </Typography>
        </div>
      </div>
      <img
        alt={type}
        className={certificateBlockBanner}
        title={type}
        src={`${WINDOWS_CDN_PATH}/certificate/${type}.png/${type}-1.png`}
      />
    </LinkWithGAClickButton>
  );
});
